module.exports = __webpack_public_path__ + "img/aqfh-img-64.eb62ff48.png";